import nFinitiDDA from '../images/productsIcons/nFinitiDDASmall.png';
import nFinitiLoan from '../images/productsIcons/nFinitiLoanSmall.png';
import nFinitiCLM from '../images/productsIcons/nFinitiCLMSmall.png';
import nFinitiPAYMENT from '../images/productsIcons/nFinitiPAYMENTSmall.png';
// import nFinitiLutPayments from "../images/productsIcons/LutMerchant.png"  //lut square image
// import nFinitiLutPayments from "../images/productsIcons/LutCircle.png"  // lut circle image
import nFinitiLutPayments from "../images/productsIcons/LutBlackAndWhite.png"  //lut black & white


const DynamicProductIcon = (product: any) => {
    const IconStyles = {
        height: "20px",
        width: "20px"
    };
    let selectedLogo;
    // if(product.productId == "abf246e6-667e-11ee-8c99-0242ac120002" || product.productId == "bbf246e6-667e-11ee-8c99-0242ac130003"){
    //         selectedLogo = <img style={IconStyles} src={nFinitiLoan} alt="nFinitiLoan" />;
    // }else if(product.productId == "23606c48-cd33-49b1-b14d-8dcbc0916629"){
    //     selectedLogo = <img style={IconStyles} src={nFinitiCLM} alt="nFinitiCLM" />;
    // }else if(product.productId == "7097515a-89d7-11ee-b9d1-0242ac120002"){
    //     selectedLogo = <img style={IconStyles} src={nFinitiDDA} alt="nFinitiDDA" />;
    // }else{
    //     selectedLogo = "--";
    // }
    if (product.productName == "Commercial Loan") {
        selectedLogo = <img  src={nFinitiLoan} alt="nFinitiLoan" />;
    } else if (product.productName == "CLM") {
        selectedLogo = <img src={nFinitiCLM} alt="nFinitiCLM" />;
    } else if (product.productName == "Commercial DDA") {
        selectedLogo = <img  src={nFinitiDDA} alt="nFinitiDDA" />;
    }else if (product.productName == "Payments") {
        selectedLogo = <img src={nFinitiPAYMENT} alt="nFinitiPAYMENT" />;
    }
    else if (product.productName == "Lüt Payments") {
        selectedLogo = <img src={nFinitiLutPayments} alt="nFinitiLutPayments" />;
    }
     else {
        selectedLogo = "--";
    }
    return (
        <div className='productIcon'>
           {selectedLogo}
        </div>
    )
}

export default DynamicProductIcon;